import { useEffect } from 'react'
import pb from '@/lib/pocketbase'
import { useAuthStore } from '@/stores/authStore'
import type { ExtendedUser, UserRole } from '@/types/auth'

export function useAuth() {
  const user = useAuthStore((s) => s.user)
  const role = useAuthStore((s) => s.role)
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const assignedKegiatanIds = useAuthStore((s) => s.assignedKegiatanIds)
  const initialize = useAuthStore((s) => s.initialize)
  const logout = useAuthStore((s) => s.logout)

  useEffect(() => {
    initialize()
  }, [initialize])

  const isSuperAdmin = role === 'super_admin'
  const isStadion = role === 'stadion'
  const isAnggota = role === 'anggota'

  const isStadionFor = (kegiatanId: string) => {
    if (isSuperAdmin) return true
    if (isStadion) return assignedKegiatanIds.includes(kegiatanId)
    return false
  }

  return {
    user,
    role,
    isAuthenticated,
    assignedKegiatanIds,
    isSuperAdmin,
    isStadion,
    isAnggota,
    isStadionFor,
    logout,
    pb,
  }
}
